import { NeuButton } from "@neutron/react";
import { interpolateColor } from "../../shared/hooks/utils";
// import { useEffect, useState } from "react";

type FillType = "primary" | "secondary" | "tertiary" | "tertiary-plain";
type color = "blue" | "orange" | "red";

interface ButtonProps {
    children?: React.ReactNode,
    /** Appends the specified color to `neu-color-` and adds it as a CSS class */
    color?: color,
    fillType?: FillType,
    id?: string,
    className?: string,
    disabled?: boolean,
    size?: 'small' | undefined,
    onClick?: () => void,
    //theme?: "blue" | "orange" | "red"
}

/** 
 * Wrapper around `<NeuButton>` 
 * @NeutronUpdate The way that the color themeing works internally will have to be changed for Neutron 3
 * `fill` needs to be replaced with `kind` with the different values listed [here](https://github.com/UXCOE/uxc-neutron-sdk-web/blob/46a2d480b396abf44b8254c6f338d28dfae466ad/docs/migration/components/Button.md)
 * `color` works differently in Neutron 3 and may require the use of the commented-out `theme` property
 */


export function Button(props: ButtonProps) {
    return (<div id={props.id} className="neu-button-wrap d-inline-block">
            <NeuButton color={props.color} className={`${props.className ? props.className : ''} ${interpolateColor(props.color)}`} size={props.size} kind={props.fillType} onClick={() => props.disabled ? null : props.onClick?.()} disabled={props.disabled}>
                {props.children}
            </NeuButton>
        </div>
    )
}